import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { FormCard } from './interactions/FormCard.js';
import { PermissionApprovalCard } from './interactions/PermissionApprovalCard.js';
import { ExternalActionCard } from './interactions/ExternalActionCard.js';
import { PlanApprovalCard } from './interactions/PlanApprovalCard.js';
import { QuestionCard } from './interactions/QuestionCard.js';
import { ToolApprovalCard } from './interactions/ToolApprovalCard.js';
import { useRemoteUICopy } from './copy.js';
export function InteractionPanel({ request, onResponse, questionDraft, onQuestionDraftChange, formDraft, onFormDraftChange, planFeedback, onPlanFeedbackChange }) {
    const copy = useRemoteUICopy();
    const [failure, setFailure] = useState();
    const failureMessage = failure ? copy.interactionResponseError(failure.error) : undefined;
    const [pending, setPending] = useState(false);
    const inFlight = useRef(false);
    async function respond(response) {
        if (!onResponse || inFlight.current)
            return;
        inFlight.current = true;
        setFailure(undefined);
        setPending(true);
        try {
            await onResponse(request.requestId, response);
        }
        catch (error) {
            setFailure({ error });
            inFlight.current = false;
            setPending(false);
        }
    }
    if (request.kind === 'form') {
        return _jsx(FormCard, { draft: formDraft, onDraftChange: onFormDraftChange, request: request, onResponse: respond, pending: pending, disabled: !onResponse, failure: onResponse ? failureMessage : copy.interactionUnavailableReason(request.kind) });
    }
    if (!onResponse) {
        return _jsxs("section", { className: "agent-interaction agent-interaction-unavailable", role: "status", children: [_jsx("strong", { children: copy.interactionUnavailable }), _jsx("p", { children: copy.interactionUnavailableReason(request.kind) })] });
    }
    if (request.kind === 'tool_approval'
        && request.allowedDecisions.includes('allow')
        && request.allowScopes.length === 0) {
        return _jsxs("section", { className: "agent-interaction agent-interaction-invalid", role: "alert", children: [_jsx("strong", { children: copy.invalidInteraction }), _jsx("p", { children: copy.missingApprovalScope })] });
    }
    switch (request.kind) {
        case 'permission_approval':
            return _jsx(PermissionApprovalCard, { request: request, onResponse: respond, pending: pending, failure: failureMessage });
        case 'external_action':
            return _jsx(ExternalActionCard, { request: request, onResponse: respond, pending: pending, failure: failureMessage });
        case 'question':
            return _jsx(QuestionCard, { request: request, onResponse: respond, pending: pending, failure: failureMessage, draft: questionDraft, onDraftChange: onQuestionDraftChange });
        case 'plan_approval':
            return _jsx(PlanApprovalCard, { feedback: planFeedback, onFeedbackChange: onPlanFeedbackChange, request: request, onResponse: respond, pending: pending, failure: failureMessage });
        case 'tool_approval':
            return _jsx(ToolApprovalCard, { request: request, onResponse: respond, pending: pending, failure: failureMessage });
        default: {
            const unsupported = request;
            return _jsxs("section", { className: "agent-interaction agent-interaction-unsupported", role: "status", children: [_jsx("strong", { children: copy.unsupportedInteraction }), _jsx("p", { children: typeof unsupported.kind === 'string' ? unsupported.kind : copy.unknownInteraction })] });
        }
    }
}
//# sourceMappingURL=InteractionPanel.js.map